import { Box, Button, Paper, Typography } from "@mui/material";
import { IconArrowRight } from "@tabler/icons-react";
import felixAnalytics from "../../../../felixAnalytics";
import { radius } from "../../../../theme";

const FERRAMENTA_URL = "https://felixconecta.com";

/** Divulgação com prazo: banner esquecido no painel envelhece pior que banner
 *  que expira. Revisar a data ao renovar a campanha. */
const DIVULGADO_ATE = new Date("2026-11-30T23:59:59-03:00");

/** Chamado pelo painel, que monta os blocos em `Grid item` com padding próprio:
 *  um item com filho nulo deixaria um vão de 16px. */
export function extratoBannerVisivel(): boolean {
  return new Date() <= DIVULGADO_ATE;
}

/**
 * Divulgação da ferramenta de extrato no painel do contador.
 *
 * O público-alvo é exatamente quem já está logado aqui: contador que fecha o mês
 * de vários clientes. Abre em aba nova de propósito — ninguém deve perder o
 * painel para ir conhecer.
 *
 * Placa sólida em `accent-2` (lavanda), e não tint: o card precisa ler como OUTRA
 * solução, não como mais uma seção da Felix — o índigo `accent` marca todas as
 * affordances do app e diluiria a distinção. O par `tertiary.main` /
 * `tertiary.contrastText` já resolve o contraste (4,9:1) nos dois temas.
 *
 * É uma quebra deliberada da regra de card do DESIGN.md (superfície + hairline).
 * Vale porque é bloco de divulgação, não conteúdo de trabalho — e por isso tem
 * prazo para sumir.
 */
export default function ExtratoBanner() {
  return (
    <Paper
      elevation={0}
      sx={{
        position: "relative",
        p: 2.5,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
        gap: { xs: 2, sm: 3 },
        borderRadius: `${radius.xl}px`,
        bgcolor: "tertiary.main",
        color: "tertiary.contrastText",
      }}
    >
      <Box flex={1} minWidth={0}>
        <Typography variant="eyebrow" component="p" sx={{ opacity: 0.72 }}>
          Nova solução
        </Typography>
        <Typography variant="h3" sx={{ mt: 0.75 }}>
          {`Coleta automática do `}
          {/* Sem cor no itálico: sobre a lavanda sólida o accent sumiria, e creme
              em 18px/600 não alcança o contraste de texto grande. O itálico
              sozinho carrega a ênfase. */}
          <Box component="span" sx={{ fontStyle: "italic" }}>
            extrato PJ
          </Box>
          , via Open Finance.
        </Typography>
        <Typography variant="body1" sx={{ mt: 0.75, opacity: 0.86 }}>
          Conecta a conta do cliente sem pedir senha e já vincula cada lançamento
          ao plano de contas do seu escritório.
        </Typography>
      </Box>

      <Button
        variant="contained"
        color="secondary"
        href={FERRAMENTA_URL}
        target="_blank"
        rel="noopener noreferrer"
        endIcon={<IconArrowRight size={18} />}
        onClick={() => felixAnalytics.track("extrato_banner_click")}
        sx={{
          flexShrink: 0,
          alignSelf: { xs: "flex-start", sm: "center" },
          whiteSpace: "nowrap",
        }}
      >
        Conhecer o Felix Conecta
      </Button>
    </Paper>
  );
}
